module.exports = __webpack_public_path__ + "img/ecg.1b23427a.png";